import { SimpleChartManager } from "../simple";

/**
 * Classe gerenciadora dos gráficos múltiplo
 */
export class MultiChartManager extends SimpleChartManager {
  constructor(instance) {
    super(instance);
  }
}